import React from 'react'
import { Box, Link, type SxProps, Typography } from '@mui/material'
import { ejentaAppVersion } from '../../utils/apiUtils'

interface IFooterProps {
  isFullscreen?: boolean
}

function renderCopyright (props: IFooterProps): JSX.Element {
  const styles: SxProps = { display: 'flex', justifyContent: 'center', mb: 1, fontWeight: 350 }
  if (props.isFullscreen) {
    styles.color = 'gray'
    styles.fontSize = 12
  }

  return (
    <Box className='footer__copyright'>
      {props.isFullscreen && <Typography variant='caption' sx={{ color: 'gray', fontSize: 10 }}>v{ejentaAppVersion}</Typography>}
      <Box sx={styles}>&copy; 2012–2023 Ejenta, Inc.</Box>
    </Box>
  )
}

function AppFooter (props: IFooterProps): JSX.Element {
  const renderLinks = (): JSX.Element => {
    const styles = {
      mr: props.isFullscreen ? 3 : 0,
      opacity: props.isFullscreen ? 0.7 : 1,
      fontSize: props.isFullscreen ? 13 : 'inherit'
    }
    return (
      <>
        <Link underline='none' color='secondary' href='//ejenta.com' target='_blank' rel='noopener noreferrer' sx={styles}>
          {props.isFullscreen ? 'About us' : 'About'}
        </Link>
        <Link underline='none' color='secondary' href='//ejenta.com/terms.pdf' target='_blank' rel='noopener noreferrer' sx={styles}>
          {props.isFullscreen ? 'Terms of Service' : 'Terms'}
        </Link>
        <Link underline='none' color='secondary' href='//ejenta.com/privacy.pdf' target='_blank' rel='noopener noreferrer' sx={styles}>
          {props.isFullscreen ? 'Privacy policy' : 'Privacy'}
        </Link>
      </>
    )
  }

  const renderDefault = (): JSX.Element => {
    return (
      <Box>
        {renderCopyright(props)}

        <Box data-testid='footer__links' sx={{ mb: 1, display: 'flex', justifyContent: 'space-between' }}>
          {renderLinks()}
        </Box>
      </Box>
    )
  }

  const renderBasic = (): JSX.Element => {
    return (
      <Box data-testid='footer__links' sx={{ display: 'flex', justifyContent: 'space-between', backgroundColor: 'rgba(0,0,0,.85)', alignItems: 'center', p: 1 }}>
        <Box>{renderCopyright(props)}</Box>
        <Box> {renderLinks()} </Box>
      </Box>
    )
  }

  if (props.isFullscreen) return renderBasic()
  else return renderDefault()
}

export { AppFooter }
